var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"asset-sensitivity",class:_vm.sensitivity,on:{"click":function($event){$event.stopPropagation();return _vm.openSensitivityPopup()}}},[_vm._v(" "+_vm._s(_vm.sensitivityText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }